// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CourseTiles_wrapper__Y_3QI","main":"CourseTiles_main__cgDTE","item":"CourseTiles_item__1GoQD"};